import { render } from "./AdministratProkuroriveMain.vue?vue&type=template&id=1309fd99&scoped=true"
import script from "./AdministratProkuroriveMain.vue?vue&type=script&lang=js"
export * from "./AdministratProkuroriveMain.vue?vue&type=script&lang=js"

import "./AdministratProkuroriveMain.vue?vue&type=style&index=0&id=1309fd99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1309fd99"]])

export default __exports__